import { TileLayer, WMSTileLayer } from 'react-leaflet'
import { useState } from 'react';
import './i18n/config';
import { useTranslation } from 'react-i18next';

export default function CanopyLayers({ selectedLayer = 'OSM' }: { selectedLayer?: string }) {
    const { t } = useTranslation();
    
    const layers = {
        'OSM': (
            <TileLayer 
                attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.osm.org/{z}/{x}/{y}.png"
            />
        ),
        'Google Satellite': (
            <TileLayer
                attribution='&copy; Google'
                url="https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
                maxZoom={20}
                subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
            />
        ),
        'Esri Satellite': (
            <TileLayer
                attribution='Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
            />
        ),
        'Peruskartta': (
            <WMSTileLayer
                attribution='Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
                url="https://tiles.kartat.kapsi.fi/peruskartta?"
                layers='peruskartta'
            />
        )
    };
    
    return layers[selectedLayer] || layers['OSM'];
}